<template>
  <div v-if="dataDetail">
    <app-header v-if="appUser.isNative" back-type="back-app" :title="title"></app-header>
    <!-- 已赠送进度 -->
    <div class="fixed-right-main" :style="{ top: nativeHeaderHeight + 44 + 'px' }">
      <div v-if="dataDetail.activityRuleDesc" class="explain font14" @click="explainShow = true">活动规则</div>
    </div>
    <div class="gift-card-progress" :class="{ 'has-fixed-bottom': showRewardButton }">
      <div class="progress-card">
        <div class="progress-header">
          <div class="progress-title">已赠送</div>
        </div>
        <div class="progress-body">
          <div class="progress-num">
            <span class="num-current">{{ dataDetail.cardUseCnt || 0 }}</span>
            <span class="num-total">/{{ dataDetail.cardTotalCnt || 0 }}张</span>
          </div>
          <div class="progress-bar-wrap">
            <div class="progress-bar-bg"></div>
            <div class="progress-bar-fill" :style="{ width: progressPercent + '%' }"></div>
          </div>
        </div>
        <div class="progress-desc">
          <span class="desc-text">
            {{ dataDetail.activityRuleDescSimple }}
          </span>
        </div>
      </div>

      <!-- 我的礼品卡 -->
      <div class="card-list">
        <div class="card-list-title">我的礼品卡</div>
        <div class="card-item" v-for="(item, index) in dataDetail.cardList" :key="index" @click="goGift(item)">
          <div class="card-info">
            <img class="card-img" :src="item.giftCardImg" />
            <div class="card-detail">
              <div class="card-name">{{ item.giftCardName }}</div>
              <div class="card-status status-share" v-if="item.cardStatus === 0 && item.msgCnt > 0">
                <span>已分享</span>
              </div>
              <div class="card-status" v-else :class="'status-' + item.cardStatus">
                <span>{{ item.cardStatusDesc }}</span>
              </div>
            </div>
          </div>
          <div class="btn-common" v-if="item.cardStatus === 0">去赠送</div>
        </div>
      </div>

      <!-- 活动规则弹窗 -->
      <div class="rule-mask" v-if="showRule" @click="showRule = false">
        <div class="rule-content" @click.stop>
          <div class="rule-title">活动规则</div>
          <div class="rule-body" v-html="dataDetail.activityRule"></div>
          <div class="rule-close" @click="showRule = false">我知道了</div>
        </div>
      </div>
      <div class="dialog-mask" v-if="explainShow" @click.stop="explainShow = false">
        <div class="explain-con" @click.stop="">
          <div class="title">活动规则</div>
          <div class="container">
            <div class="myrule" v-html="dataDetail.activityRuleDesc"></div>
          </div>
          <div class="know">
            <div class="btn-common" @click="explainShow = false">我知道了</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed-bottom" v-if="showRewardButton">
      <div class="btn-common" @click="goReward">领取奖励</div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { mapGetters } from 'vuex'
import { activityService } from '@/api'
import { appUser } from '@/utils'
import { getPageUrl } from '@/utils/common/url'
import { saTrack } from '@/utils/common/shence'

export default {
  name: 'GiftCardProgress',
  mixins: [Body],
  data() {
    return {
      appUser,
      title: '活动进度',
      dataDetail: null,
      showRule: false,
      activityId: '',
      explainShow: false
    }
  },
  computed: {
    ...mapGetters('args', ['shareCode']),
    progressPercent() {
      return Math.min(((this.dataDetail.cardUseCnt || 0) / this.dataDetail.cardTotalCnt) * 100, 100)
    },
    nativeHeaderHeight() {
      return parseInt(appUser.appStatusBarHeight || 0) + 44
    },
    showRewardButton() {
      return (
        this.dataDetail.applyActivityUrl &&
        Number(this.dataDetail.cardUseCnt || 0) === Number(this.dataDetail.cardTotalCnt || 0)
      )
    }
  },
  created() {
    this.activityId = this.$route.query.activityId
    if (!this.hasUser()) return
    this.getData()
  },
  activated() {
    this.getData()
  },
  methods: {
    hasUser() {
      if (!appUser.userId) {
        this.$store.dispatch('user/login/toLogin')
        return false
      }
      return true
    },
    getData() {
      activityService
        .giftCardProcess({
          activityId: this.activityId
        })
        .then(res => {
          this.dataDetail = res
          saTrack(
            'autoTrack',
            {
              web_type: '礼品卡转介绍',
              web_name: '进度查询',
              activity_id: this.dataDetail.activityId
            },
            'quick'
          )
        })
    },
    goGift(item) {
      const url = getPageUrl({
        page: 'payment.html',
        params: { cardId: item.cardNo, shareCode: this.shareCode },
        route: '/gift-card'
      })
      window.location.href = url
    },
    goReward() {
      window.location.href = this.dataDetail.applyActivityUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.gift-card-progress {
  min-height: 100vh;
  background: #f2f2f2;
  padding: 12px;
  padding-top: 20px;

  &.has-fixed-bottom {
    padding-bottom: 80px;
  }
}

.progress-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;

  .progress-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .progress-title {
      font-size: 14px;
      color: #000000;
      font-weight: 400;
    }
  }

  .progress-body {
    margin-bottom: 16px;

    .progress-num {
      display: flex;
      align-items: flex-end;
      gap: 6px;
      margin-bottom: 8px;

      .num-current {
        color: #00b25a;
        font-size: 32px;
        font-weight: 500;
        line-height: 1;
      }

      .num-total {
        color: #999999;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
        padding-bottom: 2px;
      }
    }

    .progress-bar-wrap {
      position: relative;
      height: 12px;

      .progress-bar-bg {
        background: #ebebeb;
        border-radius: 12px;
        width: 100%;
        height: 12px;
      }

      .progress-bar-fill {
        background: #00b25a;
        border-radius: 12px;
        height: 12px;
        position: absolute;
        top: 0;
        left: 0;
        transition: width 0.3s ease;
      }
    }
  }

  .progress-desc {
    background: rgba(0, 178, 90, 0.07);
    border-radius: 4px;
    padding: 12px;
    font-size: 14px;
    line-height: 150%;

    .desc-text {
      color: #999999;
    }
  }
}

.card-list {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .card-list-title {
    font-size: 14px;
    color: #000000;
    font-weight: 500;
  }

  .card-item {
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .card-info {
      display: flex;
      gap: 8px;
      align-items: flex-start;

      .card-img {
        width: 88px;
        height: 50px;
        border-radius: 2px;
        object-fit: cover;
        border: 0.25px solid rgba(255, 255, 255, 0.5);
      }

      .card-detail {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .card-name {
          font-size: 14px;
          color: #000000;
          font-weight: 500;
        }

        .card-status {
          border-radius: 2px;
          padding: 2px 4px;
          font-size: 12px;
          line-height: 1;
          display: inline-block;
          width: fit-content;

          &.status-0 {
            background: rgba(255, 128, 0, 0.1);
            border: 1px solid rgba(255, 128, 0, 0.5);
            color: #ff8000;
          }
          &.status-share {
            border: 1px solid rgba(70, 142, 227, 0.5);
            background: rgba(70, 142, 227, 0.1);
            color: #468ee3;
          }
          &.status-1,
          &.status-3 {
            color: #999;
          }
          &.status-2 {
            color: #999;
          }
        }
      }
    }

    .btn-common {
      width: 72px;
      border-radius: 24px;
      border: 1px solid rgba(0, 178, 90, 0.3);
      background: #fff;
      padding: 6px 12px;
      font-size: 12px;
      color: #00b25a;
      margin: 0;
    }
  }
}

.rule-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;

  .rule-content {
    background: #ffffff;
    border-radius: 8px;
    padding: 20px;
    width: 80%;
    max-height: 70vh;
    overflow-y: auto;

    .rule-title {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      margin-bottom: 16px;
    }

    .rule-body {
      font-size: 14px;
      line-height: 1.5;
      color: #333333;
    }

    .rule-close {
      margin-top: 20px;
      text-align: center;
      color: #00b25a;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
.fixed-right-main {
  position: fixed;
  top: 70px;
  right: 0;
  z-index: 999;
  .explain {
    background: rgba(0, 0, 0, 0.6);
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    padding: 8px 10px 8px 16px;
    color: #fff;
  }
}
.fixed-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px;
  background: #fff;
  z-index: 999;

  .btn-common {
    width: 100%;
    height: 44px;
    border-radius: 22px;
    background: #00b25a;
    color: #fff;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.explain-con {
  border: 5px solid #366c6d;
  border-radius: 8px;
  position: relative;
  height: 80vh;
  margin: 0 20px;
  margin-top: 15vh;
  background: #fff;
  padding: 45px 0px 76px;
  .title {
    position: absolute;
    top: -9px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 120px;
    height: 50px;
    line-height: 42px;
    text-align: center;
    background: url('./images/rule_title_bg.png') no-repeat;
    background-size: 100% auto;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
  .container {
    padding: 0 20px;
    line-height: 22px;
    height: 100%;
    overflow-y: auto;
  }
  .myrule {
    h3 {
      margin-top: 16px;
      margin-bottom: 5px;
      font-size: 16px;
    }
    p {
      font-size: 14px;
      color: #555;
    }
  }
  .know {
    position: absolute;
    background-color: #fff;
    bottom: 0;
    width: 100%;
    padding: 16px;
  }
}
</style>
